module.exports = __webpack_public_path__ + "static/media/budva-8.90cdce92.jpg";